import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ViewModal from 'Shared/ViewModal/ViewModal'

// TODO: Refactor all forms that use this component with the app Shared/PaymentMethods components and
//       then refactor this file to a more optimal solution to remove the renderProp
const AlertModal = ({ className, children, onClose, preventClosing, show, showCloseIcon, size, title,
                      useRenderProps }) => {
  const [modal, setModal] = useState(false)

  const toggle = () => setModal(prevState => !prevState)

  useEffect(() => {
    setModal(show)
  }, [show])

  return (
    <ViewModal className={className} isOpen={modal} onClosed={onClose} preventClosing={preventClosing}
               showCloseIcon={showCloseIcon} showOkButton={false} size={size} toggle={toggle} title={title}>
      {useRenderProps ? children({ setModal, toggle }) : children }
    </ViewModal>
  )
}

AlertModal.defaultProps = {
  onClose: () => {},
  preventClosing: false,
  title: '',
  showCloseIcon: false,
  size: 'lg',
  useRenderProps: false,
}

AlertModal.propTypes = {
  onClose: PropTypes.func,
  preventClosing: PropTypes.bool,
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  showCloseIcon: PropTypes.bool,
  size: PropTypes.string,
  useRenderProps: PropTypes.bool,
}

export default AlertModal
